import React from 'react';
import PropTypes from 'prop-types';
import { BRAND_LIBRARY_BUTTON_DEFAULT_COLOR } from 'common/constants/brandLibrary';
import { BlockVariation } from './PageContainer.styles';

export default function PageContainer({ children, ...props }) {
    return <BlockVariation {...props}>{children}</BlockVariation>;
}

PageContainer.propTypes = {
    children: PropTypes.node.isRequired,
};

PageContainer.splash = {
    ...BlockVariation.splash,
    defaultProps: {
        ...BlockVariation.splash.defaultProps,
        styles: {
            ...BlockVariation.splash.defaultProps.styles,
            backgroundColor: BRAND_LIBRARY_BUTTON_DEFAULT_COLOR,
        },
    },
};
